<mat-card class="grid-wrapper mat-elevation-z3">
    <div class="grid-container">
        <div class="grid-wallpaper">
            <img src="{{ componentWallpaper }}" />
            <div class="header-container">
                <div class="header">
                    <h1 class="mdc-typography--headline2 nomargin">{{ componentHeader }}</h1>
                </div>
            </div>
        </div>
        <div class="grid-header"></div>
        <div class="grid-content">
            <div class="map-container mat-elevation-z3">
                <div *ngIf="fishing">
                    <img
                        title="Мурикайский залив"
                        class="marker-32"
                        style="
                                left: 68%;
                                bottom: 35%;
                                "
                        src="../assets/img/fishing.png"
                    />

                    <img
                        title="Гавань Головорезов"
                        class="marker-32"
                        style="
                                left: 80%;
                                bottom: 37%;
                                "
                        src="../assets/img/fishing.png"
                    />

                    <img
                        title="Озеро слез"
                        class="marker-32"
                        style="
                                left: 74%;
                                bottom: 14%;
                                "
                        src="../assets/img/fishing.png"
                    />

                    <img
                        title="Болото Вескатус"
                        class="marker-32"
                        style="
                                left: 79%;
                                bottom: 44%;
                                "
                        src="../assets/img/fishing.png"
                    />

                    <img
                        title="Озеро замерзших слез"
                        class="marker-32"
                        style="
                                left: 13%;
                                bottom: 21%;
                                "
                        src="../assets/img/fishing.png"
                    />

                    <img
                        title="Озеро Дзерены"
                        class="marker-32"
                        style="
                                left: 41%;
                                bottom: 31%;
                                "
                        src="../assets/img/fishing.png"
                    />
                </div>

                <!-- Gathering -->
                <div *ngIf="gathering">
                    <!-- Val Tirkai -->
                    <div *ngIf="oreGalborne">
                        <img
                            title="oreGalborne"
                            class="marker-32"
                            style="
                                left: 15%;
                                bottom: 70%;
                                "
                            src="../assets/img/oreGalborne.png"
                        />
                    </div>
                    <div *ngIf="essenceObsidian">
                        <img
                            title="essenceObsidian"
                            class="marker-32"
                            style="
                                left: 15%;
                                bottom: 75%;
                                "
                            src="../assets/img/essenceObsidian.png"
                        />
                    </div>

                    <!-- Helkan District -->
                    <div *ngIf="oreGalborne">
                        <img
                            title="oreGalborne"
                            class="marker-32"
                            style="
                                left: 22%;
                                bottom: 80%;
                                "
                            src="../assets/img/oreGalborne.png"
                        />
                    </div>
                    <div *ngIf="essenceObsidian">
                        <img
                            title="essenceObsidian"
                            class="marker-32"
                            style="
                                left: 25%;
                                bottom: 80%;
                                "
                            src="../assets/img/essenceObsidian.png"
                        />
                    </div>

                    <!-- Val Kaeli -->
                    <div *ngIf="oreGalborne">
                        <img
                            title="oreGalborne"
                            class="marker-32"
                            style="
                            left: 30%;
                            bottom: 80%;
                            "
                            src="../assets/img/oreGalborne.png"
                        />
                    </div>
                    <div *ngIf="essenceObsidian">
                        <img
                            title="essenceObsidian"
                            class="marker-32"
                            style="
                            left: 35%;
                            bottom: 80%;
                            "
                            src="../assets/img/essenceObsidian.png"
                        />
                    </div>

                    <!-- Kaiator -->
                    <div *ngIf="oreXermetal">
                        <img
                            title="oreXermetal"
                            class="marker-32"
                            style="
                                left: 22%;
                                bottom: 67%;
                                "
                            src="../assets/img/oreXermetal.png"
                        />
                    </div>
                    <div *ngIf="essenceEarth">
                        <img
                            title="essenceEarth"
                            class="marker-32"
                            style="
                                left: 26%;
                                bottom: 67%;
                                "
                            src="../assets/img/essenceEarth.png"
                        />
                    </div>

                    <!-- Lorcada -->
                    <div *ngIf="oreXermetal">
                        <img
                            title="oreXermetal"
                            class="marker-32"
                            style="
                                left: 31%;
                                bottom: 67%;
                                "
                            src="../assets/img/oreXermetal.png"
                        />
                    </div>
                    <div *ngIf="essenceAzure">
                        <img
                            title="essenceAzure"
                            class="marker-32"
                            style="
                                left: 35%;
                                bottom: 67%;
                                "
                            src="../assets/img/essenceAzure.png"
                        />
                    </div>

                    <!-- Sylvanoth -->
                    <div *ngIf="oreXermetal">
                        <img
                            title="oreXermetal"
                            class="marker-32"
                            style="
                                left: 20%;
                                bottom: 55%;
                                "
                            src="../assets/img/oreXermetal.png"
                        />
                    </div>
                    <div *ngIf="herbCobseed">
                        <img
                            title="herbCobseed"
                            class="marker-32"
                            style="
                                left: 25%;
                                bottom: 55%;
                                "
                            src="../assets/img/herbCobseed.png"
                        />
                    </div>
                    <div *ngIf="herbVeridia">
                        <img
                            title="herbVeridia"
                            class="marker-32"
                            style="
                                left: 30%;
                                bottom: 55%;
                                "
                            src="../assets/img/herbVeridia.png"
                        />
                    </div>

                    <!-- Essenia -->
                    <div *ngIf="oreXermetal">
                        <img
                            title="oreXermetal"
                            class="marker-32"
                            style="
                                left: 15%;
                                bottom: 40%;
                                "
                            src="../assets/img/oreXermetal.png"
                        />
                    </div>
                    <div *ngIf="herbMushroom">
                        <img
                            title="herbMushroom"
                            class="marker-32"
                            style="
                                left: 20%;
                                bottom: 40%;
                                "
                            src="../assets/img/herbMushroom.png"
                        />
                    </div>
                    <div *ngIf="herbVeridia">
                        <img
                            title="herbVeridia"
                            class="marker-32"
                            style="
                                left: 25%;
                                bottom: 40%;
                                "
                            src="../assets/img/herbVeridia.png"
                        />
                    </div>

                    <!-- Westonia -->
                    <div *ngIf="oreShadmetal">
                        <img
                            title="oreShadmetal"
                            class="marker-32"
                            style="
                                left: 11%;
                                bottom: 27%;
                                "
                            src="../assets/img/oreShadmetal.png"
                        />
                    </div>
                    <div *ngIf="essenceAzure">
                        <img
                            title="essenceAzure"
                            class="marker-32"
                            style="
                                left: 15%;
                                bottom: 27%;
                                "
                            src="../assets/img/essenceAzure.png"
                        />
                    </div>
                    <div *ngIf="essenceOpal">
                        <img
                            title="essenceOpal"
                            class="marker-32"
                            style="
                                left: 13%;
                                bottom: 32%;
                                "
                            src="../assets/img/essenceOpal.png"
                        />
                    </div>

                    <!-- Alemantheia -->
                    <div *ngIf="oreShadmetal">
                        <img
                            title="oreShadmetal"
                            class="marker-32"
                            style="
                                left: 23%;
                                bottom: 27%;
                                "
                            src="../assets/img/oreShadmetal.png"
                        />
                    </div>
                    <div *ngIf="essenceCrimson">
                        <img
                            title="essenceCrimson"
                            class="marker-32"
                            style="
                                left: 27%;
                                bottom: 27%;
                                "
                            src="../assets/img/essenceCrimson.png"
                        />
                    </div>
                    <div *ngIf="essenceOpal">
                        <img
                            title="essenceOpal"
                            class="marker-32"
                            style="
                                left: 25%;
                                bottom: 32%;
                                "
                            src="../assets/img/essenceOpal.png"
                        />
                    </div>

                    <!-- Veritas District -->
                    <div *ngIf="herbApple">
                        <img
                            title="herbApple"
                            class="marker-32"
                            style="
                                left: 35%;
                                bottom: 30%;
                                "
                            src="../assets/img/herbApple.png"
                        />
                    </div>
                    <div *ngIf="herbMushroom">
                        <img
                            title="herbMushroom"
                            class="marker-32"
                            style="
                                left: 38%;
                                bottom: 33%;
                                "
                            src="../assets/img/herbMushroom.png"
                        />
                    </div>
                    <div *ngIf="oreNormetal">
                        <img
                            title="oreNormetal"
                            class="marker-32"
                            style="
                                left: 41%;
                                bottom: 36%;
                                "
                            src="../assets/img/oreNormetal.png"
                        />
                    </div>

                    <!-- Val Elenium -->
                    <div *ngIf="oreShadmetal">
                        <img
                            title="oreShadmetal"
                            class="marker-32"
                            style="
                                left: 21.5%;
                                bottom: 15%;
                                "
                            src="../assets/img/oreShadmetal.png"
                        />
                    </div>
                    <div *ngIf="essenceCrimson">
                        <img
                            title="essenceCrimson"
                            class="marker-32"
                            style="
                                left: 25%;
                                bottom: 15%;
                                "
                            src="../assets/img/essenceCrimson.png"
                        />
                    </div>
                    <div *ngIf="essenceAzure">
                        <img
                            title="essenceAzure"
                            class="marker-32"
                            style="
                                left: 28.5%;
                                bottom: 15%;
                                "
                            src="../assets/img/essenceAzure.png"
                        />
                    </div>

                    <!-- Val Palrada -->
                    <div *ngIf="herbMoongourd">
                        <img
                            title="herbMoongourd"
                            class="marker-32"
                            style="
                                left: 35%;
                                bottom: 15%;
                                "
                            src="../assets/img/herbMoongourd.png"
                        />
                    </div>
                    <div *ngIf="oreShadmetal">
                        <img
                            title="oreShadmetal"
                            class="marker-32"
                            style="
                                left: 38%;
                                bottom: 18%;
                                "
                            src="../assets/img/oreShadmetal.png"
                        />
                    </div>
                    <div *ngIf="herbApple">
                        <img
                            title="herbApple"
                            class="marker-32"
                            style="
                                left: 41%;
                                bottom: 21%;
                                "
                            src="../assets/img/herbApple.png"
                        />
                    </div>

                    <!-- Island of Dawn -->
                    <div *ngIf="essenceEarth">
                        <img
                            title="essenceEarth"
                            class="marker-32"
                            style="
                                left: 54%;
                                bottom: 45%;
                                "
                            src="../assets/img/essenceEarth.png"
                        />
                    </div>
                    <div *ngIf="essenceCrimson">
                        <img
                            title="essenceCrimson"
                            class="marker-32"
                            style="
                                left: 55%;
                                bottom: 41%;
                                "
                            src="../assets/img/essenceCrimson.png"
                        />
                    </div>
                    <div *ngIf="oreNormetal">
                        <img
                            title="oreNormetal"
                            class="marker-32"
                            style="
                                left: 56%;
                                bottom: 37%;
                                "
                            src="../assets/img/oreNormetal.png"
                        />
                    </div>

                    <!-- Val Oriyn -->
                    <div *ngIf="oreCobala">
                        <img
                            title="oreCobala"
                            class="marker-32"
                            style="
                                left: 62%;
                                bottom: 67%;
                                "
                            src="../assets/img/oreCobala.png"
                        />
                    </div>
                    <div *ngIf="essenceOpal">
                        <img
                            title="essenceOpal"
                            class="marker-32"
                            style="
                                left: 64%;
                                bottom: 71%;
                                "
                            src="../assets/img/essenceOpal.png"
                        />
                    </div>
                    <div *ngIf="essenceCrimson">
                        <img
                            title="essenceCrimson"
                            class="marker-32"
                            style="
                                left: 66%;
                                bottom: 75%;
                                "
                            src="../assets/img/essenceCrimson.png"
                        />
                    </div>

                    <!-- Arcadia -->
                    <div *ngIf="oreCobala">
                        <img
                            title="oreCobala"
                            class="marker-32"
                            style="
                                left: 68%;
                                bottom: 40%;
                                "
                            src="../assets/img/oreCobala.png"
                        />
                    </div>
                    <div *ngIf="herbApple">
                        <img
                            title="herbApple"
                            class="marker-32"
                            style="
                                left: 71%;
                                bottom: 40%;
                                "
                            src="../assets/img/herbApple.png"
                        />
                    </div>
                    <div *ngIf="herbVeridia">
                        <img
                            title="herbVeridia"
                            class="marker-32"
                            style="
                                left: 74%;
                                bottom: 40%;
                                "
                            src="../assets/img/herbVeridia.png"
                        />
                    </div>

                    <!-- Ostgarath -->
                    <div *ngIf="oreCobala">
                        <img
                            title="oreCobala"
                            class="marker-32"
                            style="
                                left: 83%;
                                bottom: 40%;
                                "
                            src="../assets/img/oreCobala.png"
                        />
                    </div>
                    <div *ngIf="herbMoongourd">
                        <img
                            title="herbMoongourd"
                            class="marker-32"
                            style="
                                left: 83%;
                                bottom: 45%;
                                "
                            src="../assets/img/herbMoongourd.png"
                        />
                    </div>
                    <div *ngIf="herbCobseed">
                        <img
                            title="herbCobseed"
                            class="marker-32"
                            style="
                                left: 83%;
                                bottom: 50%;
                                "
                            src="../assets/img/herbCobseed.png"
                        />
                    </div>

                    <!-- Velika -->
                    <div *ngIf="herbMoongourd">
                        <img
                            title="herbMoongourd"
                            class="marker-32"
                            style="
                                left: 65%;
                                bottom: 25%;
                                "
                            src="../assets/img/herbMoongourd.png"
                        />
                    </div>
                    <div *ngIf="oreNormetal">
                        <img
                            title="oreNormetal"
                            class="marker-32"
                            style="
                                left: 70%;
                                bottom: 25%;
                                "
                            src="../assets/img/oreNormetal.png"
                        />
                    </div>

                    <!-- Poporia -->
                    <div *ngIf="oreCobala">
                        <img
                            title="oreCobala"
                            class="marker-32"
                            style="
                                left: 75%;
                                bottom: 20%;
                                "
                            src="../assets/img/oreCobala.png"
                        />
                    </div>
                    <div *ngIf="herbMushroom">
                        <img
                            title="herbMushroom"
                            class="marker-32"
                            style="
                                left: 78%;
                                bottom: 20%;
                                "
                            src="../assets/img/herbMushroom.png"
                        />
                    </div>
                    <div *ngIf="herbCobseed">
                        <img
                            title="herbCobseed"
                            class="marker-32"
                            style="
                                left: 81%;
                                bottom: 20%;
                                "
                            src="../assets/img/herbCobseed.png"
                        />
                    </div>

                    <!-- Val Aureum -->
                    <div *ngIf="essenceEarth">
                        <img
                            title="essenceEarth"
                            class="marker-32"
                            style="
                                left: 57%;
                                bottom: 12%;
                                "
                            src="../assets/img/essenceEarth.png"
                        />
                    </div>
                    <div *ngIf="essenceOpal">
                        <img
                            title="essenceOpal"
                            class="marker-32"
                            style="
                                left: 61%;
                                bottom: 12%;
                                "
                            src="../assets/img/essenceOpal.png"
                        />
                    </div>
                    <div *ngIf="oreNormetal">
                        <img
                            title="oreNormetal"
                            class="marker-32"
                            style="
                                left: 65%;
                                bottom: 12%;
                                "
                            src="../assets/img/oreNormetal.png"
                        />
                    </div>
                </div>
                <!-- /Gathering -->

                <div *ngIf="BAM69">
                    <img
                        title="Черный огненный алкус, 69"
                        class="marker-72"
                        style="
                                left: 25%;
                                bottom: 7%;
                                "
                        src="../assets/img/quest.png"
                    />
                </div>

                <img class="map" src="../assets/img/map_world.png" />
            </div>
        </div>
        <div class="grid-toc">
            <mat-expansion-panel [expanded]="gathering" class="menu-item noshadow noback">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-checkbox class="menu-item" [(ngModel)]="gathering">Сбор</mat-checkbox>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="menu-exp-cont">
                    <mat-checkbox class="menu-item" [(ngModel)]="essenceAzure"
                        >Голубой энергетический кристалл</mat-checkbox
                    >
                    <mat-checkbox class="menu-item" [(ngModel)]="essenceCrimson"
                        >Красный энергетический кристалл</mat-checkbox
                    >
                    <mat-checkbox class="menu-item" [(ngModel)]="essenceEarth"
                        >Зеленый энергетический кристалл</mat-checkbox
                    >
                    <mat-checkbox class="menu-item" [(ngModel)]="essenceObsidian"
                        >Черный энергетический кристалл</mat-checkbox
                    >
                    <mat-checkbox class="menu-item" [(ngModel)]="essenceOpal"
                        >Белый энергетический кристалл</mat-checkbox
                    >

                    <mat-checkbox class="menu-item" [(ngModel)]="herbApple">Яблоко</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="herbCobseed">Кукуруза</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="herbMoongourd">Старая тыква</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="herbMushroom">Кадмильский гриб</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="herbVeridia">Веридия</mat-checkbox>

                    <mat-checkbox class="menu-item" [(ngModel)]="oreCobala">Кобаловый камень</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="oreGalborne">Галенитовый камень</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="oreNormetal">Норметаллический камень</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="oreShadmetal">Шадметаллический камень</mat-checkbox>
                    <mat-checkbox class="menu-item" [(ngModel)]="oreXermetal">Зерметаллический камень</mat-checkbox>
                </div>
            </mat-expansion-panel>

            <mat-checkbox class="menu-item" [(ngModel)]="fishing">Рыба</mat-checkbox>
            <mat-checkbox class="menu-item" [(ngModel)]="BAM69">БАМЫ 65-69</mat-checkbox>
        </div>
        <div class="grid-comments">
            <disqus [identifier]="pageId"></disqus>
        </div>
        <div class="grid-footer"></div>
    </div>
</mat-card>
